import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

// MSW is gone (Phase 2.9). Every `/api/*` call goes through `src/lib/api.ts`
// which prepends `VITE_API_BASE_URL` and sets `credentials: 'include'` so the
// `srab_session` HttpOnly cookie from the real BE is round-tripped.
//
// Defensive cleanup: a previously-installed `mockServiceWorker.js` SW would
// keep intercepting `/api/*` after a redeploy unless we explicitly unregister
// it. Browsers cache the controller across page loads, so users coming back
// after a hot-fix could otherwise see stale mock responses. Best-effort, no
// await — first paint should not wait on the SW registry.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) =>
      Promise.all(
        regs
          .filter((r) => r.active?.scriptURL.endsWith('/mockServiceWorker.js'))
          .map((r) => r.unregister()),
      ),
    )
    .catch(() => {
      /* ignore — unregistration is best-effort */
    })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
